if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('.product-media-modal__nav--previous');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.mediaContent = this.querySelector('.product-media-modal__content');
        this.currentCounter = this.querySelector('[data-media-current]');
        this.touchStartX = null;

        this.previousButton?.addEventListener('click', () => this.showAdjacentMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showAdjacentMedia(1));
        [this.previousButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.addEventListener('keydown', (event) => this.handleKeyboardNavigation(event));
        this.mediaContent?.addEventListener('pointerdown', (event) => this.handlePointerDown(event));
        this.mediaContent?.addEventListener('pointerup', (event) => this.handlePointerUp(event));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaItems = this.getMediaItems();
        let requestedMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!requestedMediaId) {
          const activeSlide = document.querySelector('media-gallery .product__media-item.is-active');
          if (activeSlide) {
            requestedMediaId = activeSlide.getAttribute('data-media-id')?.split('-').pop();
          }
        }
        const activeIndex = mediaItems.findIndex((element) => {
          const elId = element.getAttribute('data-media-id');
          return elId === requestedMediaId || (requestedMediaId && elId?.endsWith(requestedMediaId));
        });
        this.setActiveMedia(activeIndex >= 0 ? activeIndex : 0);
      }

      getMediaItems() {
        return Array.from(this.mediaContent?.children || []).filter((element) => element.hasAttribute('data-media-id'));
      }

      setActiveMedia(index) {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        const normalizedIndex = (index + mediaItems.length) % mediaItems.length;
        const activeMedia = mediaItems[normalizedIndex];

        window.pauseAllMedia();
        mediaItems.forEach((element) => element.classList.remove('active'));
        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.activeMediaIndex = normalizedIndex;
        if (this.currentCounter) this.currentCounter.textContent = normalizedIndex + 1;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showAdjacentMedia(direction) {
        this.setActiveMedia((this.activeMediaIndex || 0) + direction);
      }

      handleKeyboardNavigation(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.showAdjacentMedia(event.key === 'ArrowLeft' ? -1 : 1);
      }

      handlePointerDown(event) {
        if (event.pointerType === 'mouse') return;
        this.touchStartX = event.clientX;
      }

      handlePointerUp(event) {
        event.stopPropagation();
        if (this.touchStartX === null || event.pointerType === 'mouse') return;

        const movement = event.clientX - this.touchStartX;
        this.touchStartX = null;
        if (Math.abs(movement) < 45) return;
        this.showAdjacentMedia(movement > 0 ? -1 : 1);
      }
    }
  );
}
